import { MusicalNoteIcon } from "@heroicons/react/24/outline";
import {
  FaBullhorn,
  FaFilm,
  FaTrainTram,
  FaTv,
  FaUsers,
  FaUtensils,
} from "react-icons/fa6";
import { BsAirplaneFill } from "react-icons/bs";
import { FaMicrophone, FaTheaterMasks } from "react-icons/fa";
import { FaRegStar } from "react-icons/fa";
import { IoBed } from "react-icons/io5";
import { FaBus } from "react-icons/fa";
import { PiMicrophoneStage } from "react-icons/pi";
import { BsFillSuitcaseFill } from "react-icons/bs";
import { MdCategory } from "react-icons/md";
import { TbWorldWww } from "react-icons/tb";
import { FaCalendarAlt } from "react-icons/fa";
import { cn } from "../../lib/utils";

export enum KontrolIcon {
  GENERAL = "general",
  CONCERT = "concert",
  SHOW = "show",
  TRAIN = "train",
  AIRPLANE = "airplane",
  ACCOMMODATION = "accommodation",
  PROMOTION = "promotion",
  MARKETING = "marketing",
  SPECIAL = "special",
  BUS = "bus",
  REPEAT = "repeat",
  TRAVEL = "travel",
  OTHER = "other",
  ONLINE = "online",
  LUNCH = "lunch",
  MEETING = "meeting",
  TV = "tv",
  CINEMA = "cinema",
}

// Common styles for all icons
const ICON_STYLES = "h-4 w-4" as const;

// Type-safe mapping between KontrolIcon and their React components
const ICON_COMPONENTS: Record<
  KontrolIcon,
  React.ComponentType<{ className?: string }>
> = {
  [KontrolIcon.GENERAL]: FaCalendarAlt,
  [KontrolIcon.CONCERT]: MusicalNoteIcon,
  [KontrolIcon.SHOW]: FaTheaterMasks,
  [KontrolIcon.TRAIN]: FaTrainTram,
  [KontrolIcon.AIRPLANE]: BsAirplaneFill,
  [KontrolIcon.ACCOMMODATION]: IoBed,
  [KontrolIcon.PROMOTION]: FaMicrophone,
  [KontrolIcon.MARKETING]: FaBullhorn,
  [KontrolIcon.SPECIAL]: FaRegStar,
  [KontrolIcon.BUS]: FaBus,
  [KontrolIcon.REPEAT]: PiMicrophoneStage,
  [KontrolIcon.TRAVEL]: BsFillSuitcaseFill,
  [KontrolIcon.OTHER]: MdCategory,
  [KontrolIcon.ONLINE]: TbWorldWww,
  [KontrolIcon.LUNCH]: FaUtensils,
  [KontrolIcon.MEETING]: FaUsers,
  [KontrolIcon.TV]: FaTv,
  [KontrolIcon.CINEMA]: FaFilm,
};

export const mapStringToIcon = (icon: string): KontrolIcon => {
  // Check if the provided string is a valid KontrolIcon value
  if (Object.values(KontrolIcon).includes(icon as KontrolIcon)) {
    return icon as KontrolIcon;
  }
  return KontrolIcon.GENERAL;
};

export const getIcon = (icon: KontrolIcon): JSX.Element => {
  const IconComponent = ICON_COMPONENTS[icon];
  return <IconComponent className={cn(ICON_STYLES)} />;
};

export const getIconFromString = (icon: string): JSX.Element => {
  return getIcon(mapStringToIcon(icon));
};
